<template>
    <v-dialog
        :eager="eager"
        v-model="dialog"
        persistent
        :max-width="max_width"
        scrollable>
        <v-card class="elevation-0 pa-0 ma-0">
            <v-card-title class="ma-0 pa-0">
            <v-toolbar dark color="suggestion">
                <v-toolbar-title class="d-flex flex-grow-1 flex-shrink-0 text-uppercase" >
                    <slot name="title">{{title}}</slot>
                </v-toolbar-title>
                <v-btn icon dark @click="$emit('close_dialog')">
                    <v-icon>close</v-icon>
                </v-btn>
                
            </v-toolbar>
            </v-card-title>
            <v-card-text class="pa-6 ma-0">
                <slot></slot>
                <slot name="action"></slot>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default  {
    props: {
        dialog: {
            type:Boolean,
            required: true,
            default: false
        }, 
        title: {
            type: String,
            required: false,
            title: ""
        },
        max_width: {
            type: String,
            required: false,
            default:'unset'
        },
        eager: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>

<style>

</style>